export default "__VITE_ASSET__Dx9g6fKk__"